import React, { FC, MouseEvent, useCallback, useMemo } from "react";
import { Checkbox } from "antd";
import useBulkAction from "../../../../hooks/useBulkAction";
import { DocumentSetData } from "../../../../interfaces/documentSet";
import { OverviewType, useAppSelector } from "../../../../../app";
import { ADMIN_ROLE_ID } from "../../../../../common/utilities/env";

type Props = {
  documentSet: DocumentSetData;
};

const BulkActionCheckboxCell: FC<Props> = ({ documentSet }) => {
  const { selectedRows, toggleBulkActionCheckbox } = useBulkAction();
  const { overviewType } = useAppSelector((state) => state.documentSetsReducer);
  const user = useAppSelector((state) => state.userReducer.user);

  const isAdmin = useMemo(() => {
    return user?.access?.includes(ADMIN_ROLE_ID) ?? false;
  }, [user]);

  const hasActions = useMemo(() => {
    if (overviewType === OverviewType.Archived && !isAdmin) {
      return false;
    }
    return overviewType !== OverviewType.Remove;
  }, [overviewType, isAdmin]);

  const checked = useMemo(() => {
    return selectedRows.includes(documentSet.id);
  }, [selectedRows, documentSet.id]);

  const handleCheckboxClick = useCallback(
    (event: MouseEvent) => {
      event.stopPropagation();
      toggleBulkActionCheckbox(documentSet.id);
    },
    [toggleBulkActionCheckbox, documentSet.id],
  );

  if (!hasActions) {
    return <div className="bulk-action-checkbox" />;
  }

  return (
    <div className="bulk-action-checkbox" onClick={handleCheckboxClick}>
      <div className={selectedRows.length >= 1 ? "visible" : "hover"}>
        <Checkbox checked={checked} />
      </div>
    </div>
  );
};

export default BulkActionCheckboxCell;
